import {
    ALLOCATION_GROUPS,
    EXPERIMENTS,
    getAllocatedGroup,
    type AbTests,
} from '@fiverr-private/briefs_experiments_utils';
import type { MiraBriefsEmptyStateVariant } from '@fiverr-private/mira_entry_points';

const MIRA_BRIEFS_EMPTY_STATE_VARIANTS: Record<number, MiraBriefsEmptyStateVariant> = {
    [ALLOCATION_GROUPS.B]: 'chat',
    [ALLOCATION_GROUPS.C]: 'miniFlow',
    [ALLOCATION_GROUPS.D]: 'orbit',
};

/**
 * Mira entry points experiment: group A (control) or not allocated → null (today's non-Mira empty state).
 * Groups B-D render MiraBriefsEmptyState (chat / miniFlow / orbit) — the host renders nothing else
 * alongside it, since unlike `now` these variants draw the Brief creator themselves.
 */
export const getMiraBriefsEmptyStateVariant = (abTests?: AbTests): MiraBriefsEmptyStateVariant | null =>
    MIRA_BRIEFS_EMPTY_STATE_VARIANTS[getAllocatedGroup(EXPERIMENTS.MIRA_ENTRY_POINTS_V1, abTests)] ?? null;
